export default __webpack_public_path__ + "static/media/Zoom.7ed45624.svg";